import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Button } from '@app/components/shared/button/button';
import { debounceTime, distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'app-filter-audit-pending',
  imports: [ReactiveFormsModule, Button],
  templateUrl: './filter.html',
  styleUrl: './filter.css',
})
export class Filter {
  private readonly FormBuilder = inject(FormBuilder);
  form!: FormGroup;
  @Input() supplierList: string[] = [];
  @Input() branchList: string[] = [];
  @Input() showActions: boolean = true;
  @Output() onApprove = new EventEmitter();
  @Output() onDeny = new EventEmitter();
  @Output() onFilter = new EventEmitter<{
    supplier: string;
    branch: string;
    startDate: string;
    endDate: string;
    serial: string;
  }>();

  private buildForm() {
    this.form = this.FormBuilder.group({
      supplier: ['', [Validators.required]],
      startDate: ['', [Validators.required]],
      endDate: ['', [Validators.required]],
      serial: ['', [Validators.required]],
      branch: ['', [Validators.required]],
    });

    this.form.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((value) => {
        this.handleFilter();
      });
  }

  constructor() {
    this.buildForm();
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleString('es-CO');
  }

  get supplierSelected() {
    return this.form.get('supplier')?.value;
  }
  get branchSelected() {
    return this.form.get('branch')?.value;
  }

  handleApprove() {
    this.onApprove.emit();
  }

  handleDeny() {
    this.onDeny.emit();
  }

  handleFilter() {
    const { supplier, branch, startDate, endDate, serial } = this.form.value;
    this.onFilter.emit({ supplier, branch, startDate, endDate, serial });
  }
}
